import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

// Shows a message once, then sends the visitor elsewhere.
function RedirectWithMessage({ to, message }) {
  useEffect(() => { toast.error(message, { id: "access-denied" }); }, [message]);
  return <Navigate to={to} replace />;
}

// UI guard only: the API enforces the same rules on the server. Never rely on this alone.
export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground text-sm tracking-wide uppercase">Loading…</div>
      </div>
    );
  }
  // Must be a real user object with a known role, not just any truthy value
  if (!user || typeof user !== "object" || !user.id || !user.role) {
    return <RedirectWithMessage to="/login" message="Please sign in to continue." />;
  }
  if (roles && !roles.includes(user.role)) {
    return <RedirectWithMessage to="/" message="You don't have access to that page." />;
  }
  return children;
}
